import { render, staticRenderFns } from "./Expo.vue?vue&type=template&id=b316a074&"
import script from "./Expo.vue?vue&type=script&lang=js&"
export * from "./Expo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports